import { FileScopeType } from 'SharedDir/declarations/files';

export const FILE_ACCESS = {
  // Файл доступен ВСЕМ, включая поисковым ботам
  PUBLIC: {
    isPublic: true,
    authorizedOnly: false,
  },
  // Файл доступен авторизованным пользователям
  PRIVATE: {
    isPublic: false,
    authorizedOnly: true,
  },
  // Файл доступен только создателю
  USER_ONLY: {
    isPublic: false,
    authorizedOnly: false,
  },
};

export enum FilePropValidationRule {
  maxFileSize = 'max-file-size',
  accept = 'accept',
  maxTotalSize = 'max-total-size',
  maxFiles = 'max-files',
  filter = 'filter',
}

export enum NestedLinkType {
  none = 'none',
  singleLevel = 'single_level',
  allNested = 'all_nested',
}

export const WordExtensions = ['docx', 'doc'];

export const ExcelExtensions = ['xlsx', 'xml', 'xls'];

export const ImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp'];
/**
 * Типы файлов для которых доступен предпросмотр в рамках системы
 */
export const previewKnowFiles = [
  ...WordExtensions,
  'pdf',
  'txt',
  ...ExcelExtensions,
  ...ImageExtensions,
];
